import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { NavL2 } from '@mesh.ai/rabbit';
import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { useNonDeerRouteDetails } from 'Deer/hooks/useNonDeerRouteDetails';
import { setL2Visible, useSelectIsL2Visible } from 'Deer/slice/DeerNav.slice';
import { useDispatch } from 'react-redux';

import { isMobileView } from 'constants/isMobileView';
import { isNetchexLogin } from 'constants/netChexConstants';

const SecondaryNavNonDeer = () => {
  const matchedNonDeerRoute = useNonDeerRouteDetails();

  const { hasSidePanel, navComponent: NavComponent, route } = matchedNonDeerRoute || {};
  const isL2Visible = useSelectIsL2Visible();

  const dispatch = useDispatch();

  const setL2VisibleHandler = () => {
    dispatch(
      setL2Visible({
        isL2Visible: !isL2Visible,
      })
    );
  };

  useEffect(() => {
    if (hasSidePanel && !isMobileView()) {
      dispatch(
        setL2Visible({
          isL2Visible: true,
        })
      );
    }
  }, [dispatch, hasSidePanel]);

  // hide collapse button on review form filling and review result page in netchex nav desktop view
  const hideCollapseButton =
    (route === staticRoutesWithCustomSidebar.reviewsFormFilling ||
      route === staticRoutesWithCustomSidebar.reviewsResultPage) &&
    isNetchexLogin &&
    !isMobileView();

  return (
    <Box
      style={{
        zIndex: 10,
        width: isL2Visible ? '100%' : '0',
        flexGrow: 1,
        position: isMobileView() ? 'absolute' : undefined,
      }}
    >
      <NavL2 open={isL2Visible} onToggle={setL2VisibleHandler} showCollapseButton={!hideCollapseButton}>
        <NavComponent />
      </NavL2>
    </Box>
  );
};

export { SecondaryNavNonDeer };
